import api from './api';

export default {
  /**
   * Fetch APOT incidents report rows.
   * @param {Object} params
   * @param {string} [params.dateFrom]
   * @param {string} [params.dateTo]
   * @param {string} [params.sequenceNumbers]
   * @param {string} [params.incidentNumbers]
   * @param {string} [params.firstName]
   * @param {string} [params.lastName]
   * @param {number} [params.page=1]
   * @param {number} [params.perPage=25]
   * @returns {Promise<{data: Array, total: number, page: number, perPage: number}>}
   */
  getApotIncidents(params) {
    return api()
      .get('apot-incidents', { params })
      .then(r => r.data);
  },

  /**
   * Export APOT incidents to XLSX file.
   * @param {Object} params
   * @param {string} [params.dateFrom]
   * @param {string} [params.dateTo]
   * @param {string} [params.sequenceNumbers]
   * @param {string} [params.incidentNumbers]
   * @param {string} [params.firstName]
   * @param {string} [params.lastName]
   * @returns {Promise<Blob>}
   */
  exportApotIncidents(params) {
    return api()
      .get('apot-incidents/export', {
        params,
        responseType: 'blob',
      })
      .then(r => r.data);
  },

  /**
   * Save/Update APOT incident data.
   * @param {number|null} id - Incident ID (if updating existing incident)
   * @param {Object} data
   * @param {string} data.firstName - Patient First Name
   * @param {string} data.lastName - Patient Last Name
   * @param {string} data.dateOfBirth - Patient Date of Birth
   * @param {string} data.sex - Patient Gender
   * @returns {Promise<Object>}
   */
  saveApotIncident(id, data) {
    return api()
      .post(`apot-incidents/${id}`, data)
      .then(r => r.data);
  },
};
